<svelte:options
  customElement={{
    tag: "oc-tab-panel-v1",
    shadow: "none",
    props: {},
  }}
/>

<script lang="ts">
  import { onMount } from "svelte";
  import type { TabPanelProps } from "./TabBarV1.types.js";

  /*                                                         */
  let props: TabPanelProps = $props();

  const Host = $host();

  onMount(() => {
    /*                       */
    Host.setAttribute("role", "tabpanel");
    Host.setAttribute("aria-hidden", "true");
  });
</script>
